<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-09-30 15:28:09
 * @Version: 1.0
 * @Description: 个人中心运输列表页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="content-container">
    <div class="goods-head">
      <div class="slider-list" @click="toggleState($event)">
        <div :class="{ 'selected': !state}" class="item">待发布</div>
        <div :class="{ 'selected': state}" class="item">已发布</div>
      </div>
      <!-- 查询表单  -->
      <div class="main">
        <el-form ref="form" :model="queryParams" :inline="true" label-width="100px">
          <div :class="{'showMore' : showMore}" class="condition-area">
            <div class="icon-content" @click="toggleShowMore">
              <i :class="[showMore?'iconshang':'iconxia']" class="icon iconfont" />
            </div>
            <div class="condition-group">
              <el-form-item label="始发地 :" prop="startPlace" label-width="106px">
                <el-cascader
                  v-model="queryParams.startPlace"
                  :options="area"
                  :filterable="true"
                  :props="{ expandTrigger: 'hover', checkStrictly: true }"
                  @expand-change="expandChange"
                />
              </el-form-item>
              <el-form-item label="目的地 :" prop="stopPlace" label-width="105px">
                <el-cascader
                  v-model="queryParams.stopPlace"
                  :options="area"
                  :filterable="true"
                  :props="{ expandTrigger: 'hover', checkStrictly: true }"
                  @expand-change="expandChange"
                />
              </el-form-item>
              <el-form-item label="运输方式:" prop="transportType" label-width="100px">
                <el-select v-model="queryParams.transportType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in transportType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="运输品类:" prop="goodsType" label-width="100px">
                <el-select v-model="queryParams.goodsType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in goodsType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="发布日期:" prop="createTime" label-width="100px">
                <el-date-picker
                  v-model="queryParams.createTime"
                  type="daterange"
                  :editable="false"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </el-form-item>
            </div>
          </div>
          <div class="button-group">
            <el-form-item class="form-item form-item-sou">
              <el-button
                size="small"
                style="background-color: #BE2316;border-color: #F56C6C;"
                class="form-item-btn"
                type="primary"
                @click="loadData"
              >
                <i class="el-icon-search" />查询
              </el-button>
              <el-button
                size="small"
                style="background-color: #BE2316;border-color: #F56C6C;"
                class="form-item-btn"
                type="primary"
                @click="resetForm"
              >
                <i class="el-icon-delete-solid" />
                重置
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <!--存入表格数据-->
    <article class="operations">
      <template v-if="!state">
        <el-button
          size="small"
          class="form-item-btn"
          type="primary"
          style="background-color: #BE2316;border-color: #F56C6C;"
          @click="batchPublish"
        >
          <i class="el-icon-plus" />批量发布
        </el-button>
        <el-button
          size="small "
          class="form-item-btn"
          type="primary"
          style="background-color: #BE2316;border-color: #F56C6C;"
          @click="batchDel"
        >
          <i class="el-icon-delete-solid" />批量删除
        </el-button>
      </template>
    </article>

    <div v-loading="viewManager.loading" class="goods-data">
      <div class="goods-data-header">
        <ul>
          <li>
            <el-checkbox v-model="allSelection" @change="selection()" />
          </li>
          <li>起始地/目的地</li>
          <li>运输方式</li>
          <li>运输品类</li>
          <li>承载能力</li>
          <!-- <template v-if="state">
            <li>邀请数量</li>
          </template>-->
          <template v-if="!state">
            <li>创建时间</li>
          </template>
          <template v-if="state">
            <li>发布时间</li>
          </template>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" class="goods-data-body" :class="{'has-publish': state}">
        <template v-if="data.transport.length < 1 && !viewManager.loading">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(transport, index) of data.transport">
          <div :key="index" class="data-item">
            <ul>
              <li>
                <div class="vertical-align">
                  <el-checkbox v-model="transport.selection" @change="change()" />
                </div>
              </li>
              <li>
                <div
                  class="vertical-align"
                >{{ transport.startPlaceLabel }}-{{ transport.stopPlaceLabel }}</div>
              </li>
              <li>
                <div class="vertical-align">{{ transport.transportTypeLabel }}</div>
              </li>
              <li>
                <div class="vertical-align">{{ transport.goodsTypeLabel }}</div>
              </li>
              <li>
                <div class="vertical-align">{{ transport.weight }}吨</div>
              </li>
              <!-- <template v-if="state">
                <li>
                  <a
                    href="javascript:void 0"
                    @click="popInvitationList(transport.id)"
                  >1111</a>
                </li>
              </template>-->
              <li v-if="!state">
                <div class="vertical-align">{{ transport.createDate|_data }}</div>
              </li>
              <li v-if="state">
                <div class="vertical-align">{{ transport.publishDate|_data }}</div>
              </li>
              <li>
                <template v-if="state">
                  <el-button type="text" @click="popRecommendList(transport)">货源推荐</el-button>
                  <el-divider direction="vertical" />
                </template>
                <template v-if="!state">
                  <el-button type="text" @click="edit(transport.id)">编辑</el-button>
                  <el-divider direction="vertical" />
                  <el-button type="text" @click="del(transport.id)">删除</el-button>
                  <el-button type="text" @click="publish(transport)">发布</el-button>
                </template>
                <el-button v-if="state" type="text" @click="revoke(transport)">取消发布</el-button>
                <!-- <el-divider direction="vertical" /> -->
                <el-button
                  class="show-deatils"
                  plain
                  size="small"
                  @click="showDetail(transport, index, $event)"
                >
                  详情
                  <i :class="{'expand': !transport.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <transportFullInfo v-show="!transport.hidden" :transport="transport" />
          </div>
        </template>
      </div>
      <div class="goods-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>

    <!-- 以上是主页面的组成dom  -->

    <el-dialog
      :visible.sync="invitationManager.visible"
      title="邀请详情"
      width="80%"
      @click="invitationManager.close"
    >
      <goodsOfferDialog :transport-id="transportId" />
    </el-dialog>
    <!-- 货源推荐 -->
    <recommendDialog ref="goods-recommend" />
  </div>
</template>

<script>
import { Page } from '@/utils/commonDataModel'
import transportFullInfo from '../components/transportFullInfo'
import {
  getTransportInManager,
  del,
  batchDel,
  batchIssueAndRevoke
} from '@/api/personal/find/transportManager'
import goodsOfferDialog from './goodsOfferDialog'
import recommendDialog from './recommendDialog'
import mixinsFunction from '@/utils/mixinsFunction'
import { formatTime } from '@/shared/filters/formatTimeFilter'
import { requiredRules } from '../dataConfig/rules'

const PUBLISH_STATE = 1

const UNPUBLISH = 0

const requiredItems = () => {
  const keys = []
  for (const key in requiredRules) {
    if (requiredRules[key].some(item => item.required)) {
      keys.push(key)
    }
  }
  return keys
}

const validateData = (item) => {
  for (const key in item) {
    if (requiredItems().some(i => i === key)) {
      if (typeof item[key] === 'string' && item[key] === '') {
        return { state: false, key: key }
      } else if (Object.prototype.toString.call(item[key]) === 'Array' && item[key].length == 0) {
        return { state: false, key: key }
      }
    }
  }
}

export default {
  name: 'TransportList',
  components: {
    transportFullInfo,
    goodsOfferDialog,
    recommendDialog
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      // 当前点击项的运力id
      transportId: '',
      // 地区
      area: [],
      // 货物类型
      goodsType: [],
      // 运输方式
      transportType: [],
      invitationManager: {
        visible: false,
        close: () => {
          this.invitationManager.visible = false
        }
      },
      data: {
        transport: []
      },

      allSelection: false,
      showMore: false,
      // 表格数据
      pagination: new Page(),
      // 验证数据一致性
      rules: {
        radioGroup: [
          { required: true, message: '请至少选择一项', trigger: 'change' }
        ],
        demandArea: [
          { required: true, message: '请输入需求面积', trigger: 'blur' },
          { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
        ],
        enterpriseName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        companyContacts: [
          { required: true, message: '请输入公司联系人', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ]
      },
      queryParams: {
        startPlace: [],
        stopPlace: [],
        transportType: '',
        goodsType: '',
        createTime: []
      },
      state: false
    }
  },
  computed: {
    getPublishState() {
      return this.state ? 1 : 0
    }
  },
  watch: {
    state: function() {
      this.cleanModal(this.queryParams)
      this.loadData()
    }
  },
  created: function() {
    // if (this.$route.params.noticeId != undefined) {}
    this.init()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    async init() {
      await Promise.all([
        this.getArea(),
        this.getTransportType(),
        this.getGoodsType(),
        this.loadData()
      ]).then(data => {
        [this.area, this.transportType, this.goodsType] = data
      })
      this.viewManager.loading = false
    },
    // 显示详情
    showDetail(transport, index, event) {
      if (transport.hidden) {
        // 把展开的关闭
        this.data.transport.forEach((item, position) => {
          // 要关闭的元素
          if (!item.hidden) {
            const lastState = event.target.getBoundingClientRect()
            item.hidden = true
            // 如果当前元素比要展开的元素在前面， 需要向上滚动
            if (position < index) {
              setTimeout(() => {
                this.computePositionScroll(event.target, lastState)
              }, 50)
            }
          }
        })
      }
      transport.hidden = !transport.hidden
    },
    // 转换参数
    exchangeData(data) {
      const handle = {
        get(target, key, proxy) {
          if ((key === 'startPlace' || key === 'stopPlace') && target[key]) {
            if (target[key].length > 0) {
              return target[key] instanceof Object
                ? target[key].length === 1
                  ? target[key].join('#')
                  : target[key].join('#') + '#'
                : target[key]
            } else {
              return ''
            }
          } else if (key === 'createTime') {
            if (target[key].length < 1) {
              return ''
            } else {
              for (const item in target[key]) {
                target[key][item] = formatTime(
                  target[key][item],
                  'YYYY-MM-DD HH:mm:ss'
                )
              }
              return target[key].toString()
            }
          } else {
            return target[key]
          }
        }
      }
      if (window && window.Proxy) {
        const p = new Proxy(data, handle)
        const proxyData = Object.assign({}, p)
        return proxyData
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = handle.get(data, key)
        }
        return proxyData
      }
    },
    toggleShowMore() {
      this.showMore = !this.showMore
    },
    toggleState(event) {
      if (!event.target.classList.contains('slider-list')) {
        this.state = !this.state
      }
    },
    popInvitationList(id) {
      this.transportId = id
      // 打开弹窗,根据id查询出对应列表
      this.invitationManager.visible = true
    },
    // 打开货源推荐
    popRecommendList(item) {
      // 根据id查询出对应列表
      console.log(item)
      this.$refs['goods-recommend'].open(item)
    },
    // 重置表单并刷新
    resetForm() {
      this.cleanModal(this.queryParams)
      // this.$refs['form'].resetFields()
      this.loadData()
    },
    // 回到表格顶部
    scrollTop() {
      this.$el.scrollIntoView()
    },
    // 子项选择
    change() {
      this.allSelection = this.data.transport.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.transport.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 更改每页的数据条数
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 更改页数
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    invitedDetails() {
      this.$refs['invitedDetails'].open(arguments[0])
    },
    batchDel() {
      const ids = this.data.transport
        .filter(item => item.selection)
        .map(item => item.id)
      if (ids.length > 0) {
        this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            batchDel({ id: ids.join(',') })
              .then(data => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.loadData()
              })
              .catch(error => {
                console.error(error)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的数据!'
        })
      }
    },

    // 准备查询数据
    loadData() {
      this.queryParams.sendStatus = this.getPublishState
      const params = this.exchangeData(this.queryParams)
      this.loadTableData(params)
    },
    // 查询数据
    loadTableData(params) {
      // this.viewManager.loading = true
      getTransportInManager(this.pagination, params)
        .then(data => {
          console.log(data)
          this.data.transport = data.result.rows.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
              item.selection = false
            }
            if (item.fileUrl !== '') {
              item.fileUrl = String(item.fileUrl).split(',')
            }
            return item
          })
          this.pagination.total = data.result.total
        })
        .catch(() => {
          // console.error(error)
        })
        // .finally(() => {
        //   // 数据刷新时  全选状态为false
        //   this.allSelection = false
        //   this.scrollTop()
        //   this.viewManager.loading = false
        // })
    },
    del(id) {
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (id) {
            del({ id: id })
              .then(data => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                // eslint-disable-next-line no-undef
                this.loadData()
              })
              .catch(() => {
                // console.error(error)
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 编辑运力
    edit(id) {
      this.$router.push({
        path: './publish-transport',
        query: { transportId: id }
      })
    },
    //  下架运力
    revoke(transport) {
      // console.log(transport)
      // if (item.numberInvitation > 0) {
      //   this.$message({
      //     type: 'warning',
      //     message: '已邀请报价，不得取消发布!'
      //   })
      //   return false
      // }
      const id = transport.id
      this.$confirm('此操作将下架这条运力数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (id) {
            batchIssueAndRevoke({ ids: id, sendStatus: UNPUBLISH })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '下架成功!'
                })
                this.loadData()
              })
              .catch(() => {
                // console.error(error)
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下架'
          })
        })
    },
    // 批量发布运力
    batchPublish() {
      let items = this.data.transport
        .filter(item => item.selection)
      if (items.length > 0) {
        items = items.filter((item, index) => {
          const result = validateData(item)
          if (result && !result.state) {
            this.$message({
              type: 'error',
              message: `所选第${parseInt(index) + 1}条数据不完整，请先填写完整再发布!`
            })
            return false
          }
          return true
        }).map(item => item.id)
        if (items.length == 0) return false
        batchIssueAndRevoke({ ids: items.toString(), sendStatus: PUBLISH_STATE })
          .then(data => {
            this.$message({
              type: 'success',
              message: '发布成功!'
            })
            this.loadData()
          })
          .catch(() => {
            // console.error(error)
          })
      } else {
        this.$message({
          type: 'warning',
          message: '请选择要发布的数据!'
        })
      }
    },
    // 发布运力
    publish(item) {
      const result = validateData(item)
      if (result && !result.state) {
        this.$message({
          type: 'error',
          message: `数据不完整，请先填写完整再发布!`
        })
        return false
      }
      batchIssueAndRevoke({ ids: item.id, sendStatus: PUBLISH_STATE })
        .then(data => {
          this.$message({
            type: 'success',
            message: '发布成功!'
          })
          this.loadData()
        })
        .catch(() => {
          // console.error(error)
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";
@import "@/styles/formLayout.scss";

$main-color: #be2316;

.button-group {
  min-width: 190px;
}
.input-icon{
  font-size:0
}
/deep/.el-input--suffix .el-input__inner{
  width: 198px!important;
  padding-right: 58px!important
}
.condition-area {
  width: 75% !important;
  height: 60px;
  transition: all .8s ease-in-out;
  &.showMore {
    height: auto;
    transition: all .8s ease-in-out;
  }
}

.content-container {
  box-sizing: border-box;
  margin-top: 1px;
  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;

    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      /deep/ [class^="el-icon-"] {
        margin-right: 0.5rem;
      }
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
    /deep/ [class^="el-icon-"] {
      margin-right: 0.5rem;
    }
  }

  .goods-data {
    .goods-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 51px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      // margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        // width: calc(100% - 16px);
        // padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          > div.vertical-align {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            position: relative;
          }
          margin-left: auto;
          margin-right: auto;
          text-align: center;
          &:first-child {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 23%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:last-child {
            flex-basis: 180px !important;
          }
        }
      }
    }

    .goods-data-body {
      &.has-publish {
        .data-item {
          ul > li:nth-child(6) {
            // color:  #2E6FDA;
          }
        }
      }
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .data-item {
        // height: 83px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
        border-radius: 4px;
        margin: 8px 0px;
        // border: 1px solid #ebeef5;
        position: relative;
        box-sizing: border-box;

        ul {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          min-height: 83px;
          // height: 83px;
          position: relative;
          background-color: white;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);

          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            > div.vertical-align {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              width: 100%;
              position: relative;
            }
            margin-left: auto;
            margin-right: auto;
            font-size: 15px;
            min-width: 50px;

            text-align: center;
            position: relative;
            &:first-child {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 23%;
              color: #333;
            }
            &:nth-child(3) {
              flex-basis: 10%;
              color: #333;
            }
            &:nth-child(4) {
              flex-basis: 10%;
              color: #333;
            }
            &:nth-child(5) {
              flex-basis: 10%;
              color: #333;
            }
            &:nth-child(6) {
              flex-basis: 10%;
              color: #333;
            }
            &:nth-child(7) {
              flex-basis: 10%;
              color: #333;
            }
            &:last-child {
              flex-basis: 180px !important;
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(5) {
                color: black !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 0.5s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .goods-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
}

/deep/.el-date-editor--daterange, .el-select {
  width: 200px;
  .el-range-input {
    font-size: 12px;
  }
}
</style>
